// =========================
// 📂 Convenios
// =========================
export const dataConvenios = [
  {
    id: 1,
    title: "CAIPTLAX",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/1.pdf",
  },
  {
    id: 2,
    title: "INE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/2.pdf",
  },
  {
    id: 3,
    title: "Recaudación",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/3.pdf",
  },
  {
    id: 4,
    title: "FEPADE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/4.pdf",
  },
  {
    id: 5,
    title: "COPARMEX",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/5.pdf",
  },
  {
    id: 6,
    title: "Tribunal Electoral de Jalisco",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/6.pdf",
  },
  {
    id: 7,
    title: "Tribunal Electoral de Tlaxcala",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/7.pdf",
  },
  {
    id: 8,
    title: "Insituto Estatal de la Mujer, Tribunal Electoral de Tlaxcala",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/8.pdf",
  },
  {
    id: 9,
    title: "UNAM",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/9.pdf",
  },
  {
    id: 9.1,
    title: "UNAM Anexo",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/9.1.pdf",
  },
  {
    id: 10,
    title: "TET",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/10.pdf",
  },
  {
    id: 11,
    title: "UVT",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/11.pdf",
  },
  {
    id: 12,
    title: "Acuerdo de Trabajo PArticipación Ciudadana",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/12.pdf",
  },
  {
    id: 13,
    title: "IAIPTLAX-ITE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/13.pdf",
  },
  {
    id: 14,
    title: "INE-ITE PELO 2020-2021",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/14.pdf",
  },
  {
    id: 15,
    title: "ISR 2019",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/15.pdf",
  },
  {
    id: 16,
    title: "SEDECO-ITE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/16.pdf",
  },
  {
    id: 17,
    title: "SEPE-INE-ITE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/17.pdf",
  },
  {
    id: 18,
    title: "SPF-ITE (ISR 2020)",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/18.pdf",
  },
  {
    id: 19,
    title: "ITE PCG-0209-2021",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/19.pdf",
  },
  {
    id: 20,
    title: "ITE-PGJ-CJM",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/20.pdf",
  },
  {
    id: 21,
    title: "ITE-SEPE USET",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/21.pdf",
  },
  {
    id: 22,
    title: "ITE-CONALEP",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/22.pdf",
  },
  {
    id: 23,
    title: "ITE-COBAT",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/23.pdf",
  },
  {
    id: 24,
    title: "ITE-CECYTE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/24.pdf",
  },
  {
    id: 25,
    title: "ITE-COMISIÓN EJECUTIVA DEL SISTEMA ANTICORRUPCIÓN",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/25.pdf",
  },
  {
    id: 26,
    title: "ITE-IMPUESTO SOBRE LA RECAUDACIÓN DE RENTA",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/26.pdf",
  },
  {
    id: 27,
    title: "ITE-CONTRALORIA DEL EJECUTIVO",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/27.pdf",
  },
  {
    id: 28,
    title: "ITE-PODER JUDICIAL DEL ESTADO DE TLAXCALA",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/28.pdf",
  },
  {
    id: 29,
    title: "ITE-IEM",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/29.pdf",
  },
  {
    id: 30,
    title: "TET-ITE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/30.pdf",
  },
  {
    id: 31,
    title: "ITE - CIUDADANIA A.C",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/31.pdf",
  },
  {
    id: 32,
    title: "ITE - SECRETARIA DE FINANZAS",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/32.pdf",
  },
  {
    id: 33,
    title: "ITE - UPET",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/33.pdf",
  },
  {
    id: 34,
    title: "ITE - SISTEMA ANTICORRUPCIÓN",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/34.pdf",
  },
  {
    id: 35,
    title: "MPIO. SAN FRANCISCO TETLANOHCAN",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/35.pdf",
  },
  {
    id: 36,
    title: "RED MUNDIAL DE JOVENES POLITICOS 2022",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/36.pdf",
  },
  {
    id: 37,
    title: "UAT 2022",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/37.pdf",
  },
  {
    id: 38,
    title: "UNAM",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/38.pdf",
  },
  {
    id: 39,
    title: "UPET 2022",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/39.pdf",
  },
  {
    id: 40,
    title: "CEDH 01 SEP 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/40.pdf",
  },
  {
    id: 41,
    title: "COLEGIO DE TLAXCALA, A.C. 17 AGO 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/41.pdf",
  },
  {
    id: 42,
    title: "DDESER 23 AGO 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/42.pdf",
  },
  {
    id: 43,
    title: "GENERAL INE-ITE PEC 2023-2024  07 SEP 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/43.pdf",
  },
  {
    id: 44,
    title: "INPI 01 SEP 23",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/44.pdf",
  },
  {
    id: 45,
    title: "ITE LA FUNDACION 04 SEP 23",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/45.pdf",
  },
  {
    id: 46,
    title: "SECRETARÍA DE BIENESTAR TLAXCALA 04 SEP 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/46.pdf",
  },
  {
    id: 47,
    title: "UAT  21 AGO 23  OK",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/47.pdf",
  },
  {
    id: 48,
    title: "UAT FACULTAD DERECHO 21 AGO 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/48.pdf",
  },
  {
    id: 49,
    title: "IEM TET ITE 13 NOV 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/49.pdf",
  },
  {
    id: 50,
    title: "ITE-PJET 04 DIC 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/50.pdf",
  },
  {
    id: 51,
    title: "ITE INE SEP 07 DIC 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/51.pdf",
  },
  {
    id: 52,
    title: "ITE EL COLEGIO DE TLAXCALA 06 DIC 2023",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/52.pdf",
  },
  {
    id: 53,
    title: "ITE y el Instituto Estatal Electoral de Chihuahua",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/53.pdf",
  },
  {
    id: 54,
    title: "INE ITE Y GOBIERNO DEL ESTADO",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/54.pdf",
  },
  {
    id: 55,
    title: "ITE Y AMCEE",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/55.pdf",
  },
  {
    id: 56,
    title: "ITE y SF",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/56.pdf",
  },
  {
    id: 57,
    title: "ITE y CANIRAC",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/57.pdf",
  },
  {
    id: 58,
    title: "ITE y LA SMyT",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/58.pdf",
  },
  {
    id: 59,
    title: "ITE y SAET",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/59.pdf",
  },
  {
    id: 60,
    title: "ITE y Dirección de atención a migrantes",
    url: "https://itetlax.org.mx/assets/pdf/transparencia/convenios/60.pdf",
  },
];

// =========================
// 📂 Informes Anuales
// =========================
export const dataInformesAnuales = [
  { id: 1, title: "2015" },
  { id: 2, title: "2016" },
  { id: 3, title: "2017" },
  { id: 4, title: "2018" },
  { id: 5, title: "2019" },
  { id: 6, title: "2020" },
  { id: 7, title: "2021" },
  { id: 8, title: "2022" },
  { id: 9, title: "2023" },
  // { id: 10, title: "2024" },
];

// =========================
// 📂 Información Financiera
// =========================
export const dataInfFinanciera = [
  {
    id: 1,
    titleItem: "Remuneración Mensual",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/1.pdf",
    typeDocument: "pdf",
  },
  {
    id: 2,
    titleItem: "Padrón de Proveedores",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/2.pdf",
    typeDocument: "pdf",
  },
  /* {
    id: 3,
    titleItem: "Contratos",
    linkItem: "",
    typeDocument: "",
  }, */
];

// =========================
// 📂 Información 2016
// =========================
export const dataInfo2016 = [
  /* {
    id: 1,
    titleItem: "Presupuesto de egresos aprobado",
    flushID: "presupuesto2016",
    children: [
      {
        id: 1,
        titleItem: "Presupuesto Firmado 2016",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/4.pdf",
        typeDocument: "pdf",
      },
      {
        id: 2,
        titleItem: "Acuerdo Adecuación Presupuesto ITE-CG 03-2016 20-Enero-2016",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/5.pdf",
        typeDocument: "pdf",
      },
      {
        id: 3,
        titleItem: "Acuerdo de Presupuesto de Egresos 2016 ITE-CG 08-2015 30-Septiembre-2016",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/6.pdf",
        typeDocument: "pdf",
      },
      {
        id: 4,
        titleItem: "Acuerdo de Presupuesto de Egresos 2016 ITE-CG 08-2015 30-Septiembre-2016",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/7.pdf",
        typeDocument: "pdf",
      },
    ],
  }, */
  /* {
    id: 2,
    titleItem: "Balance general, estado de ingresos y egresos",
    flushID: "balanceGralEI",
    children: [
      {
        id: 1,
        titleItem: "Balance General",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/7.pdf",
        typeDocument: "pdf",
      },
      {
        id: 2,
        titleItem: "Estado de Egresos e Ingresos",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/8.pdf",
        typeDocument: "pdf",
      },
    ],
  }, */

];

export const dataInfo2026 = [
  {
    id: 1,
    titleItem: "Presupuesto de egresos aprobado",
    flushID: "presupuesto2016",
    children: [
      {
        id: 1,
        titleItem: "Presupuesto Aprobado 2026",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/pre_apro_2026.pdf",
        typeDocument: "pdf",
      },
    ],
  },
  /* {
    id: 2,
    titleItem: "Balance general, estado de ingresos y egresos",
    flushID: "balanceGralEI",
    children: [
      {
        id: 1,
        titleItem: "Balance General",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/7.pdf",
        typeDocument: "pdf",
      },
      {
        id: 2,
        titleItem: "Estado de Egresos e Ingresos",
        linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infFinanciera/8.pdf",
        typeDocument: "pdf",
      },
    ],
  }, */

];
// =========================
// 📂 Información Contable
// =========================
export const dataInfContable = [
  {
    id: 1,
    titleItem: "Inventario de Bienes Muebles e Inmuebles",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infContable/1.pdf",
    typeDocument: "pdf",
  },
  {
    id: 2,
    titleItem: "Manuales de Organización",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/infContable/3.pdf",
    typeDocument: "pdf",
  },
];

// =========================
// 📂 Datos Abiertos
// =========================


// =========================
// 📂 Datos Abiertos
// =========================
export const dataDatosAbiertos = [
  {
    id: 1,
    titleItem: "Cultura Cívica",
    flushID: "culturaCivica",
    children: [
      {
        id: 1,
        idModal: "informeFinal1",
        titleModal: "Informe final de Foros de Diálogo, Editorial INE.",
        titleTheme: "Cultura Cívica",
        keyWords: "Divulgación, Cultura democrática, Educación Cívica, Foros de Diálogo, Informe.",
        description:
          "Informe final de Foros de Diálogo, Editorial INE, Meta Colectiva DECEYEC-1, periodo 2024-2025, miembros SPEN del ITE",
        area: "DOECyED/Dirección de Organización Electoral, Capacitación y Educación Cívica",
        dateUpdate: "Julio 2025",
        contactName: "Coordinación de Educación Cívica",
        contactEmail: "educacion.civica@itetlax.org.mx",
        nameCharge: "Titular del Área Técnica de Consulta Ciudadana",
        subChildren: [
          {
            id: 1,
            resourseTitle:
              "Informe final de Foros de Diálogo, Editorial INE, Meta Colectiva DECEYEC-1, miembros SPEN del ITE",
            resoursePath:
              "https://itetlax.org.mx/assets/word/transparencia/datosAbiertos/1.pdf",
            typeDocument: "pdf",
          },
        ],
      },
      {
        id: 2,
        idModal: "informeFinal2",
        titleModal: "Informe final de Foros de Diálogo, Editorial INE",
        titleTheme: "Cultura Cívica",
        keyWords: "Divulgación, Cultura democrática, Educación Cívica, Talleres, Informe.",
        description:
          "Informe final de Talleres, Editorial INE, Meta Colectiva DECEYEC-2, periodo 2023-2024, miembros SPEN del ITE.",
        area: "DOECyED/Dirección de Organización Electoral, Capacitación y Educación Cívica",
        dateUpdate: "Julio 2025",
        contactName: "Coordinación de Educación Cívica",
        contactEmail: "educacion.civica@itetlax.org.mx",
        nameCharge: "",
        subChildren: [
          {
            id: 2,
            resourseTitle:
              "Informe final de Talleres, Editorial INE, Meta Colectiva DECEYEC-2, periodo 2023-2024, miembros SPEN del ITE.",
            resoursePath:
              "https://itetlax.org.mx/assets/word/transparencia/datosAbiertos/2.pdf",
            typeDocument: "pdf",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    titleItem: "Comunicación Social",
    flushID: "comunicacionSocial",
    children: [
      {
        id: 1,
        idModal: "debates",
        titleModal:
          "Difusión de debates para el Proceso Electoral Local Ordinario",
        titleTheme: "Debates",
        keyWords: "Debate, difusión, candidatos",
        description:
          "Información relacionada a la implementación y participantes en los debates a partir de le Reforma Local Electoral (2015) en el Proceso Electoral Local Ordinario desde 2015 y hasta el 2021.",
        area: "ATCSyP- Área Técnica de Comunicación Social y Prensa",
        dateUpdate: "Julio 2025",
        contactName: "Mtra. Elízabeth González Serrano",
        contactEmail: "comunicacion@itetlax.org.mx",
        nameCharge: "Titular del Área Técnica de Comunicación Social y Prensa",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Anexo - Debates",
            resoursePath:
              "https://itetlax.org.mx/assets/pdf/transparencia/datosAbiertos/1.pdf",
            typeDocument: "pdf",
          },
        ],
      },
      {
        id: 2,
        idModal: "difusoresPREP",
        titleModal: "Difusores oficiales PREP",
        titleTheme: "Programa de Resultados Electorales Preliminares",
        keyWords: "PREP, Difusores, Jornada Electoral, Medios de Comunicación",
        description:
          "Información relacionada a la presentación de los medios de comunicación designados para fingir como difusores oficiales del Programa de Resultados Electorales Preliminares (PREP).",
        area: "ATCSyP- Área Técnica de Comunicación Social y Prensa",
        dateUpdate: "agosto 2021",
        contactName: "Mtra. Elízabeth González Serrano",
        contactEmail: "comunicacion@itetlax.org.mx",
        nameCharge: "Titular del Área Técnica de Comunicación Social y Prensa",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Anexo - Difusores Oficiales PREP",
            resoursePath:
              "https://itetlax.org.mx/assets/pdf/transparencia/datosAbiertos/2.pdf",
            typeDocument: "pdf",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    titleItem: "Organización Electoral",
    flushID: "organizacionElectoral",
    children: [
      {
        id: 1,
        idModal: "organizacionElectoral",
        titleModal:
          "La participación ciudadana en el Proceso Electoral Local Ordinario",
        titleTheme: "Participación Ciudadana",
        keyWords:
          "Elección, Participación, Ciudadanía, Estadística, Observadores",
        description:
          "Se realiza un análisis sobre la evolución de la participación ciudadana en los Procesos Electorales Locales Ordinarios de los años 2015, 2016 y 2018 en los diferentes municipios del estado de Tlaxcala.",
        area: "DOECyEC- Dirección de Organización Electoral Capacitación y Educación Cívica",
        dateUpdate: "agosto 2021",
        contactName: "Mtra. Miriam Yolisma Báez Hernández",
        contactEmail: "miriam.yolisma@itetlax.org.mx",
        nameCharge:
          "Directora de Organización Electoral, Capacitación y Educación Cívica",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Registro de candidatos Ayuntamientos ITE 2016",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/1.xlsx",
            typeDocument: "excel",
          },
          {
            id: 2,
            resourseTitle: "Registro de candidatos Diputaciones ITE 2016",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/2.xlsx",
            typeDocument: "excel",
          },
          {
            id: 3,
            resourseTitle: "Registro de candidatos Gubernatura ITE 2016",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/3.xlsx",
            typeDocument: "excel",
          },
          {
            id: 4,
            resourseTitle:
              "Registro de candidatos Presidencias de Comunidad ITE 2016",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/4.xlsx",
            typeDocument: "excel",
          },
          {
            id: 5,
            resourseTitle: "Registro de candidaturas 2021",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/5.xlsx",
            typeDocument: "excel",
          },
          {
            id: 6,
            resourseTitle: "Registro de candidaturas Tlaxcala 2018",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/6.xlsx",
            typeDocument: "excel",
          },
          {
            id: 7,
            resourseTitle: "Respuesta a los puntos 1, 2 y 3",
            resoursePath:
              "https://itetlax.org.mx/assets/word/transparencia/datosAbiertos/2.docx",
            typeDocument: "word",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    titleItem: "Actividades del Consejo General",
    flushID: "actividadesCG",
    children: [
      {
        id: 1,
        idModal: "informeCG",
        titleModal:
          "Informe de actividades realizadas por el Consejo General",
        titleTheme: "Consejo General",
        keyWords:
          "Acuerdos, Resoluciones y Sesiones del Consejo General",
        description:
          "Informe de actividades realizadas por el Consejo General del Instituto Tlaxcalteca de Elecciones.",
        area: "SE- Secretaría Ejecutiva",
        dateUpdate: "Diciembre 2024",
        contactName: "Mtra. Elizabeth Vázquez Alonso",
        contactEmail: "secretaria@itetlax.org.mx",
        nameCharge: "Secretario Ejecutivo",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Anexo - Secretaría Ejecutiva",
            resoursePath:
              "https://itetlax.org.mx/assets/pdf/transparencia/datosAbiertos/ACTIVIDADESCONSEJOGENERAL.pdf",
            typeDocument: "pdf",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    titleItem: "Partidos Políticos",
    flushID: "partidosPoliticos",
    children: [
      {
        id: 1,
        idModal: "deuccionesPP",
        titleModal:
          "Deducciones al financiamiento público de los partidos políticosDifusión de debates para el Proceso Electoral Local Ordinario",
        titleTheme: "Partidos Políticos",
        keyWords: "Financiamiento, Multas, Partidos políticos, Sanciones",
        description:
          "Ministraciones mensuales efectivas -sin multas y sanciones- a los partidos políticos correspondiente al ejercicio fiscal 2025",
        area: "DPAyF- Dirección de Prerrogativas, Administración y Fiscalización",
        dateUpdate: "12 de Mayo 2025",
        contactName: "C.P. María Paula Escobar Aguirre",
        contactEmail: "prerrogativas@itetlax.com.mx",
        nameCharge:
          "Directora de Prerrogativas, Administración y Fiscalización",
        subChildren: [
          {
            id: 1,
            resourseTitle:
              "Deducciones al financiamiento público de los partidos políticos",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/7.xlsx",
            typeDocument: "excel",
          },
        ],
      },
      {
        id: 2,
        idModal: "padronAfiliados",
        titleModal: "Padrón de afiliados",
        titleTheme: "Partidos Políticos",
        keyWords: "Padrón de afiliados, Partidos políticos",
        description:
          "Resultado de la verificación del cumplimiento del número mínimo de militantes de los Partidos Políticos.",
        area: "DPAyF - Dirección de Prerrogativas, Administración y Fiscalización",
        dateUpdate: "14 de julio 2021",
        contactName: "C.P. Janeth Miriam Romano Torres",
        contactEmail: "janeth.romano@itetlax.org.mx",
        nameCharge:
          "Directora de Prerrogativas, Administración y Fiscalización",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Afiliados SI 14-07-2021",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/8.xlsx",
            typeDocument: "excel",
          },
          {
            id: 2,
            resourseTitle: "Afiliados NAT 11-09-2023",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/9.xlsx",
            typeDocument: "excel",
          },
          {
            id: 3,
            resourseTitle: "Afiliados PAC 11-09-2023",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/10.xlsx",
            typeDocument: "excel",
          },
          {
            id: 4,
            resourseTitle: "Afiliados PEST 14-07-2021",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/11.xlsx",
            typeDocument: "excel",
          },
          {
            id: 5,
            resourseTitle: "Afiliados PS 14-07-2021",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/12.xlsx",
            typeDocument: "excel",
          },
          {
            id: 6,
            resourseTitle:
              "Afiliados a Partido Político listado Fuerza por México 11-09-2023",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/16.xlsx",
            typeDocument: "excel",
          },
          {
            id: 7,
            resourseTitle:
              "Afiliados a Partido Político Listado Redes Sociales Progresistas 11-09-2023",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/17.xlsx",
            typeDocument: "excel",
          },
        ],
      },
    ],
  },
  {
    id: 6,
    titleItem: "Régimen Sancionador",
    flushID: "regimenSancionador",
    children: [
      {
        id: 1,
        idModal: "procedmientosES",
        titleModal: "Procedimientos Especiales Sancionadores 2021",
        titleTheme: "Régimen Sancionador",
        keyWords: "Procedimiento Especial Sancionador",
        description:
          "Información correspondiente al folio, mes de presentación, cuaderno de antecedentes, número de expediente, vía, conductas de intimidación o molestias y estatus de la queja, respecto de aquellas tramitadas mediante el Procedimiento Especial Sancionador.",
        area: "UTCE - Unidad Técnica de lo Contencioso Electoral",
        dateUpdate: "27 de agosto 2021",
        contactName: "Lic. Eloy Edmundo Hernández Fierro",
        contactEmail: "eloy.hernandez@itetlax.org.mx",
        nameCharge: "Titular de la Unidad Técnica de lo Contencioso Electoral",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Concentrado PES 2021",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/13.xlsx",
            typeDocument: "excel",
          },
        ],
      },
      {
        id: 2,
        idModal: "regimenSan",
        titleModal: "Régimen Sancionador",
        titleTheme: "Procedimiento Ordinario Sancionador",
        keyWords: "Procedimiento Ordinario Sancionador, Resolución, Expediente",
        description:
          "Información correspondiente al folio, mes de presentación, cuaderno de antecedentes, número de expediente, vía, conductas de intimidación o molestias y estatus de la queja, respecto de aquellas tramitadas mediante el Procedimiento Ordinario Sancionador.",
        area: "UTCE - Unidad Técnica de lo Contencioso Electoral",
        dateUpdate: "agosto 2021",
        contactName: "Mtra. Rubí Jazmín Gutiérrez García",
        contactEmail: "jazmin.gutierrez@itetlax.org.mx",
        nameCharge: "Titular de la Unidad Técnica de lo Contencioso Electoral",
        subChildren: [
          {
            id: 1,
            resourseTitle: "ANEXO UTCE",
            resoursePath:
              "https://itetlax.org.mx/assets/pdf/transparencia/datosAbiertos/6.pdf",
            typeDocument: "pdf",
          },
        ],
      },
    ],
  },
  {
    id: 7,
    titleItem: "Presupuesto ITE",
    flushID: "PresupuestoITE",
    children: [
      {
        id: 1,
        idModal: "presupuesto2021",
        titleModal: "Presupuesto otorgado al Instituto 2025",
        titleTheme: "Transparencia",
        keyWords: "Presupuesto, Capítulos, Prerrogativas, Partidos políticos",
        description:
          "Información relativa al presupuesto otorgado al Instituto Tlaxcalteca de Elecciones durante el ejercicio 2025, dividido por meses y capítulos, total de prerrogativas de los Partidos Políticos y presupuesto destinado a las actividades y funcionamiento del Instituto",
        area: "DPAyF- Dirección de Prerrogativas, Administración y Fiscalización",
        dateUpdate: "24 de Junio de 2025",
        contactName: "C.P. MARIA PAULA ESCOBAR AGUIRRE",
        contactEmail: "prerrogativas@itetlax.org.mx",
        nameCharge:
          "Directora de Prerrogativas, Administración y Fiscalización",
        subChildren: [
          {
            id: 1,
            resourseTitle: "Presupuesto otorgado al Instituto 2025",
            resoursePath:
              "https://itetlax.org.mx/assets/excel/transparencia/datosAbiertos/14.xlsx",
            typeDocument: "excel",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    titleItem: "Transparencia",
    flushID: "Transparencia",
    children: [
      {
        id: 1,
        idModal: "indice2025",
        titleModal: "Índice de Expedientes Reservados 2025",
        titleTheme: "Índice de Expedientes Reservados 2025",
        keyWords: "Expedientes Reservados",
        description:
          "Clasificación y desclasificación de la información",
        dateUpdate: "Agosto 2025",
        contactName: "Licda. Angela Chavez Maldonado",
        contactEmail: "transparencia@itetlax.org.mx",
        nameCharge:
          "Encargada del Área Técnica de Transparencia y Acceso a la Información",
        subChildren: [
          {
            id: 1,
            resourseTitle: "INDICE DE EXPEDIENTES RESERVADOS 2025",
            resoursePath:
              "https://itetlax.org.mx/assets/pdf/transparencia/datosAbiertos/ier2025.pdf",
            typeDocument: "pdf",
          },
        ],
      },      
    ],
  },
  {
    id: 9,
    titleItem: "Órgano Interno de Control",
    flushID: "Órgano Interno de Control",
    children: [],
  },
];

// =========================
// 📂 Reglamento
// =========================
export const dataReglamento = [
  {
    id: 1,
    titleItem: "Reglamento Interior del Instituto Tlaxcalteca de Elecciones",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/2.pdf",
  },
];

// =========================
// 📂 Jurídico
// =========================
export const dataJuridico = [
  {
    id: 1,
    titleItem:
      "Organismos Electorales Federales, Organismos Electorales Locales",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/transparencia/3.pdf",
  },
];
